import { getEnvironmentVariable } from "../../../global/environmentVariables";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../../layout/cookies/CookieFunctions";

export const getCart = () => {
  if (getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true") {
    return {};
  }
  const getGetCachedData = getLocalStorage(`cartState`);

  return getGetCachedData ? JSON.parse(getGetCachedData) : {};
};

export const updateCart = (newCart, doReducer) => {
  if (getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true") {
    return;
  }
  try {
    if (newCart && Object.keys(newCart).length) {
      setLocalStorage("cartState", JSON.stringify(newCart));
    } else {
      removeLocalStorage("cartState");
    }
  } catch (err) {}

  doReducer(newCart || {});
  return {};
};

export function updateCartItem(product, qty, doReducer) {
  if (
    getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" ||
    !product?.id
  ) {
    return {};
  }

  const newCart = getCart();
  if (newCart?.items === undefined) {
    newCart.items = [];
  }
  let isItemFound = false;
  const newItems = [];

  newCart.items.forEach((item) => {
    if (item.id === product?.id) {
      isItemFound = true;
      if (qty > 0) {
        item.qty = qty;
        newItems.push(item);
      }
    } else {
      newItems.push(item);
    }
  });

  if (!isItemFound && qty > 0) {
    newItems.push({
      id: product.id,
      name: product.name,
      imageFileId: product.imageFileId,
      qty: qty,
      lp: product.loyaltyPoints,
    });
  }
  newCart.items = newItems;
  updateCart(newCart, doReducer);
  return newCart;
}

export function addToCart(product, qty, doReducer) {
  if (
    getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") !== "true" ||
    !product?.id
  ) {
    return {};
  }

  const newCart = getCart();
  if (newCart?.items === undefined) {
    newCart.items = [];
  }
  let isItemFound = false;
  newCart.items.forEach((item) => {
    if (item.id === product?.id) {
      item.qty += qty;
      isItemFound = true;
    }
  });

  if (!isItemFound) {
    newCart.items.push({
      id: product.id,
      name: product.name,
      imageFileId: product.imageFileId,
      qty: qty,
      lp: product.loyaltyPoints,
    });
  }
  updateCart(newCart, doReducer);
  return newCart;
}
